import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Svg from '../../../../../component/Svg';
import Input from "../../../../../core/Inputs/DefaultInput";
import Axios from "axios";
import { toast } from 'react-toastify';
import AuthHeader from '../../../Authentication/AuthHeader';

const emailRegex = /^(?!.*[\/?])[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

const ContactUs = () => {
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState('');

    const [nameError, setNameError] = useState(false)
    const [userName, setuserName] = useState("");

    useEffect(() => {
        setNameError(name.trim().length > 99);
        setuserName("Name Charector Limit Exceeded");
    }, [name]);


    const [validEmail, setValidEmail] = useState(false)
    const [blankEmail, setBlankEmail] = useState(0)
    const [emailError, setEmailError] = useState('')
    const [emailSuccessMsg, setEmailSuccessMsg] = useState('')

    useEffect(() => {
        setValidEmail(emailRegex.test(email));
        setEmailError('This is not a valid email')
        // handleFormSubmit();
    }, [email])

    const handleEmailChange = (e) => {
        // setEmailError('');
        // setEmailSuccessMsg('');
        setEmail(e.target.value);
    }

    const submitContact = async (e) => {
        e.preventDefault();
        if (name !== "" && email !== "" && message !== "") {
            if (emailRegex.test(email)) {
                try {
                    const response = await Axios.post(process.env.REACT_APP_NODE_API_URL + "/users/contactformsubmit", {
                        name: name,
                        email: email,
                        message: message
                    });
                    if (response.data.statusCode === 200) {
                        toast.success("Contact Form is Submitted");
                        setName('');
                        setEmail('');
                        setMessage('');
                        setTimeout(() => {
                            window.location = '/admin/login';
                        }, 2000);

                    } else {
                        toast.error("Contact Form Not Submitted");
                    }
                } catch (error) {
                    console.error("Error submitting contact form:", error);
                    toast.error("An error occurred. Please try again later.");
                }
            } else {
                toast.error("Please enter a valid email address.");
            }
        } else {
            if (name === "") {
                setNameError(true)
                setuserName("Name Can't be  empty")
            }
            if (email === "") {
                setBlankEmail(1);
                setEmailError('Email is Required');
            }
            toast.error("Please fill in all fields.");

        }
    };

    const handleNameChange = (e) => {
        if (e.target.value.length > 99) {
            setNameError(true)
            setuserName("Name Charector Limit Exceeded")
        }
        else {
            setNameError(false)
        }
        if (name === '') {
            setNameError(true)
            setuserName('Name cannot be empty')
        }
        setName(e.target.value);
    };


    return (
        <>
            <div className='d-flex flex-column site-main-wrapper login-page'>
                <AuthHeader />
                <div className="flex-grow-1 main-content-wrap d-flex align-items-center justify-content-center">
                    <div className="container">
                        <div className="form-outer-wrapper">

                            <form onSubmit={submitContact}>
                                <div className="form-wrapper mb__20">
                                    <div className="form-heading text-center">
                                        <h3>Get in touch</h3>
                                        <p>Get our all info and also can message us directly from here</p>
                                    </div>
                                    <div className="field-wrapper">
                                        <div className={`mb__20 position-relative`}>

                                            <Input
                                                type='text'
                                                view='outlined'
                                                dense={false}
                                                color='default'
                                                label=''
                                                placeholder='Enter your name'
                                                clearButton={true}
                                                fill={true}
                                                className={"formsinput login-input"}
                                                value={name}
                                                onChange={(e) => setName(e.target.value)}
                                                aria-invalid={nameError ? "false" : "true"}
                                                maxLength={100}
                                            />
                                            {

                                                (nameError) ?
                                                    <>
                                                        <div className={(!nameError) ? "success" : "validation-msg"} >
                                                            {(!nameError) ? '' : userName}
                                                        </div>
                                                    </>

                                                    : ''
                                            }
                                        </div>
                                        <div className={`mb__20 position-relative`}>

                                            <Input
                                                type='text'
                                                view='outlined'
                                                dense={false}
                                                color='default'
                                                label=''
                                                placeholder='Enter email address'
                                                clearButton={true}
                                                fill={true}
                                                className={"formsinput login-input"}
                                                value={email}
                                                onChange={(e) => setEmail(e.target.value)}
                                                onInput={handleEmailChange}
                                                aria-invalid={validEmail ? "false" : "true"}
                                            />
                                            {

                                                (email.length > 0 || blankEmail === 1) ?
                                                    <>

                                                        <div className={(validEmail) ? "success" : "validation-msg"} >
                                                            {(validEmail) ? '' : emailError}
                                                        </div>
                                                    </>

                                                    : ''
                                            }
                                        </div>
                                        <div className={`mb__20 position-relative`}>
                                            <textarea
                                                placeholder='Enter your message'
                                                name="message"
                                                className="form-control bp3-input"
                                                rows={3}
                                                defaultValue={""}
                                                value={message}
                                                onChange={(e) => setMessage(e.target.value)}
                                            />
                                        </div>
                                    </div>
                                    <div className="button-wrap mb-0">
                                        <button
                                            type="submit"
                                            className="formsbutton btn-primary btn mb-0 w-100"
                                        >
                                            Submit
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
                <div className="outer-form-text text-center d-none">
                    <ul className="form-menu">
                        <li>
                            <Link to="/admin/terms-of-use" target="_blank">Terms of Use</Link>
                        </li>
                        <li>
                            <Link to="/admin/privacy-policy" target="_blank">Privacy Policy</Link>
                        </li>
                        <li>
                            <Link to="/admin/cookie-policy" target="_blank">Cookie Policy</Link>
                        </li>
                    </ul>
                </div>
            </div>
        </>
    );
};

export default ContactUs;
